import { MessageTemplateTranslationDto } from "../../dto/message-templates/message-template-translations.dto";
import { MessageTemplateTranslation } from "../../models/message-template.model";

export class MessageTemplateTranslationMapper {
  public static toModel(dto: MessageTemplateTranslationDto): MessageTemplateTranslation {
    return {
      languageId: dto.language_id,
      text: dto.text
    }
  }

  public static toDto(m: MessageTemplateTranslation): MessageTemplateTranslationDto {
    return {
      language_id: m.languageId,
      text: m.text
    }
  }
}
